import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../../context.js';

import Loading from '../../../components/loading.js';
import Helmet from "../../../components/helmet.js";

function PatientsStatistics() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState(null);
  
  // Pagination for all lists
  const step = 5;
  const [limitWithoutProjects, setLimitWithoutProjects] = useState(step);
  const [limitMultipleProjects, setLimitMultipleProjects] = useState(step);
  const [limitWithoutPlans, setLimitWithoutPlans] = useState(step);
  const [limitMultiplePlans, setLimitMultiplePlans] = useState(step);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/analytics/patients/statistics', {})
      .then((response) => {
        setStatistics(response.data);
        setLoading(false);
      })
      .catch((e) => {
        context.addError(e);
        context.removeSpiner(u);
      })
      .finally(() => {
        context.removeSpiner(u);
      });
  }, []);

  function extendWithoutProjectsLimit() {
    setLimitWithoutProjects(limitWithoutProjects + step);
  }

  function extendMultipleProjectsLimit() {
    setLimitMultipleProjects(limitMultipleProjects + step);
  }

  function extendWithoutPlansLimit() {
    setLimitWithoutPlans(limitWithoutPlans + step);
  }

  function extendMultiplePlansLimit() {
    setLimitMultiplePlans(limitMultiplePlans + step);
  }

  function renderPatientsWithoutProjects(patients, limit) {
    if (!patients || patients.length === 0) {
      return (
        <div className="card-header sm last">
          <div className="typo-normal-150 text-muted">No patients found.</div>
        </div>
      );
    }

    // Sort patients by name
    const sortedPatients = [...patients].sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });

    // Limit the number of patients displayed
    const limitedPatients = sortedPatients.slice(0, limit);

    return limitedPatients.map((patient, index) => {
      return (
        <div key={index} className="card-header clickable sm" onClick={() => navigate(`/patient/${patient.id}/card?tab=projects`)}>
          <div className="row">
            <div className="col-xs-6">
              <div className="typo-strong-150">{patient.name}</div>
            </div>
            <div className="col-xs-2 text-center">
              <div className="typo-strong-150">{patient.statusType}</div>
            </div>
            <div className="col-xs-4 text-center">
              <div className="typo-strong-150">{patient.projectsTotal}</div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderPatientsWithMultipleProjects(patients, limit) {
    if (!patients || patients.length === 0) {
      return (
        <div className="card-header sm last">
          <div className="typo-normal-150 text-muted">No patients found.</div>
        </div>
      );
    }

    // Sort patients by name
    const sortedPatients = [...patients].sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });

    // Limit the number of patients displayed
    const limitedPatients = sortedPatients.slice(0, limit);

    return limitedPatients.map((patient, index) => {
      return (
        <div key={index} className="card-header clickable sm" onClick={() => navigate(`/patient/${patient.id}/card?tab=projects`)}>
          <div className="row">
            <div className="col-xs-6">
              <div className="typo-strong-150">{patient.name}</div>
            </div>
            <div className="col-xs-2 text-center">
              <div className="typo-strong-150">{patient.statusType}</div>
            </div>
            <div className="col-xs-4 text-center">
              <div className="typo-strong-150">{patient.projectsConcurrent}</div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderPatientsWithoutPlans(patients, limit) {
    if (!patients || patients.length === 0) {
      return (
        <div className="card-header sm last">
          <div className="typo-normal-150 text-muted">No patients found.</div>
        </div>
      );
    }

    // Sort patients by name
    const sortedPatients = [...patients].sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });

    // Limit the number of patients displayed
    const limitedPatients = sortedPatients.slice(0, limit);

    return limitedPatients.map((patient, index) => {
      return (
        <div key={index} className="card-header clickable sm" onClick={() => navigate(`/patient/${patient.id}/card?tab=plans`)}>
          <div className="row">
            <div className="col-xs-6">
              <div className="typo-strong-150">{patient.name}</div>
            </div>
            <div className="col-xs-2 text-center">
              <div className="typo-strong-150">{patient.statusType}</div>
            </div>
            <div className="col-xs-4 text-center">
              <div className="typo-strong-150">{patient.plansTotal}</div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderPatientsWithMultiplePlans(patients, limit) {
    if (!patients || patients.length === 0) {
      return (
        <div className="card-header sm last">
          <div className="typo-normal-150 text-muted">No patients found.</div>
        </div>
      );
    }

    // Sort patients by name
    const sortedPatients = [...patients].sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });

    // Limit the number of patients displayed
    const limitedPatients = sortedPatients.slice(0, limit);

    return limitedPatients.map((patient, index) => {
      return (
        <div key={index} className="card-header clickable sm" onClick={() => navigate(`/patient/${patient.id}/card?tab=plans`)}>
          <div className="row">
            <div className="col-xs-6">
              <div className="typo-strong-150">{patient.name}</div>
            </div>
            <div className="col-xs-2 text-center">
              <div className="typo-strong-150">{patient.statusType}</div>
            </div>
            <div className="col-xs-4 text-center">
              <div className="typo-strong-150">{patient.plansTotal}</div>
            </div>
          </div>
        </div>
      );
    });
  }

  if (loading) {
    return (
      <>
        <Helmet title="Analytics | Patient Analytics Dashboard" />
        <Loading />
      </>
    );
  }

  if (!statistics) {
    return (
      <>
        <Helmet title="Analytics | Patient Analytics Dashboard" />
        <div className="card mb-2">
          <div className="card-header sm">
            <div className="typo-normal-150">No data available.</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet title="Analytics | Patient Analytics Dashboard" />

      <div className="container">
        <div className="row mb-4">
          <div className="col-xs-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Patient Analytics Dashboard</div>
                <div className="typo-normal-175">Comprehensive overview of patient enrollment status and project assignments across your GUIDE Model program. Track patient alignment, identify data gaps, and monitor program participation</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">

            {/* Patients without projects card */}
            <div className="card mb-2">
              <div className="card-header sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="w-75">
                    <div className="typo-strong-175">{statistics.patientsWithoutProjects.length} patients without projects</div>
                    <div className="typo-normal-150">These patients are not assigned to any projects and may need attention.</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-6">
                    <div className="typo-strong-150">Patient Name</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-150">Status</div>
                  </div>
                  <div className="col-xs-4 text-center">
                    <div className="typo-strong-150">Projects Count</div>
                  </div>
                </div>
              </div>
              {renderPatientsWithoutProjects(statistics.patientsWithoutProjects, limitWithoutProjects)}

              {(statistics.patientsWithoutProjects.length !== 0 && limitWithoutProjects < statistics.patientsWithoutProjects.length) && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="item typo-normal-150 mt-1 mb-1" onClick={() => extendWithoutProjectsLimit()}>show more</div>
                </div>
              )}
            </div>

            {/* Patients with multiple projects card */}
            <div className="card mb-2">
              <div className="card-header sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="w-75">
                    <div className="typo-strong-175">{statistics.patientsWithMultipleProjects.length} patients with multiple projects</div>
                    <div className="typo-normal-150">These patients have more than one project assigned, which may indicate overlapping care coordination.</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-6">
                    <div className="typo-strong-150">Patient Name</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-150">Status</div>
                  </div>
                  <div className="col-xs-4 text-center">
                    <div className="typo-strong-150">Projects Count</div>
                  </div>
                </div>
              </div>
              {renderPatientsWithMultipleProjects(statistics.patientsWithMultipleProjects, limitMultipleProjects)}

              {(statistics.patientsWithMultipleProjects.length !== 0 && limitMultipleProjects < statistics.patientsWithMultipleProjects.length) && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="item typo-normal-150 mt-1 mb-1" onClick={() => extendMultipleProjectsLimit()}>show more</div>
                </div>
              )}
            </div>

            {/* Patients without plans card */}
            <div className="card mb-2">
              <div className="card-header sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="w-75">
                    <div className="typo-strong-175">{statistics.patientsWithoutPlans.length} patients without treatment plans</div>
                    <div className="typo-normal-150">These patients are not assigned to any treatment plans and may need attention.</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-6">
                    <div className="typo-strong-150">Patient Name</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-150">Status</div>
                  </div>
                  <div className="col-xs-4 text-center">
                    <div className="typo-strong-150">Plans Count</div>
                  </div>
                </div>
              </div>
              {renderPatientsWithoutPlans(statistics.patientsWithoutPlans, limitWithoutPlans)}

              {(statistics.patientsWithoutPlans.length !== 0 && limitWithoutPlans < statistics.patientsWithoutPlans.length) && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="item typo-normal-150 mt-1 mb-1" onClick={() => extendWithoutPlansLimit()}>show more</div>
                </div>
              )}
            </div>

            {/* Patients with multiple plans card */}
            <div className="card mb-2">
              <div className="card-header sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="w-75">
                    <div className="typo-strong-175">{statistics.patientsWithMultiplePlans.length} patients with multiple treatment plans</div>
                    <div className="typo-normal-150">These patients have more than one treatment plan assigned, which may indicate overlapping care coordination.</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-6">
                    <div className="typo-strong-150">Patient Name</div>
                  </div>
                  <div className="col-xs-2 text-center">
                    <div className="typo-strong-150">Status</div>
                  </div>
                  <div className="col-xs-4 text-center">
                    <div className="typo-strong-150">Plans Count</div>
                  </div>
                </div>
              </div>
              {renderPatientsWithMultiplePlans(statistics.patientsWithMultiplePlans, limitMultiplePlans)}

              {(statistics.patientsWithMultiplePlans.length !== 0 && limitMultiplePlans < statistics.patientsWithMultiplePlans.length) && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="item typo-normal-150 mt-1 mb-1" onClick={() => extendMultiplePlansLimit()}>show more</div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default PatientsStatistics;
